module.exports = __webpack_public_path__ + "img/facility.9e4ba040.svg";